import { ProgressBarDemo } from "./ProgressBarDemo";
import { SegmentedProgressBarDemo } from "./SegmentedProgressBarDemo";
import { TooltipDemo } from "./TooltipDemo";

export function StatusFeedback() {
	return (
		<section id="status-feedback" className="demo-category">
			<h1>Status & Feedback</h1>
			<section id="progress-group">
				<h2>Progress Bar</h2>
				<ProgressBarDemo />
				<SegmentedProgressBarDemo />
			</section>
			<TooltipDemo />
		</section>
	);
}
